import styled, { css } from "styled-components";
import AntInput from "antd/es/input";

export const textAreaStyles = css`
  .ant-input {
    color: ${(p) => p.theme.colors.textColor};
    background: ${(p) => p.theme.colors.cardBgColor} !important;
    color: ${(p) => p.theme.colors.primaryGrey};
    border-color: ${(p) => p.theme.colors.lightBorderGrey};
  }

  color: ${(p) => p.theme.colors.textColor};

  .ant-input-textarea:after {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }

  .ant-input-clear-icon,
  .anticon.ant-input-clear-icon {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }

  &.ant-input-affix-wrapper:focus-within {
    box-shadow: none !important;
  }

  ::placeholder {
    color: ${(p) => p.theme.colors.lightestGrey};
  }
`;

const TextArea = styled(AntInput.TextArea)`
  ${textAreaStyles};
`;

export default TextArea;
